import { LoggingModule } from "@pns-fe/sdk-common-modules";
class BaseInfoModule {
  constructor() {
    this.userInfo = {};
  }
  init(config) {
    LoggingModule.info("[BaseInfoModule]: init");
  }
  getUserInfo() {
    LoggingModule.info("[BaseInfoModule]: getUserInfo");
    return this.userInfo;
  }
  setUserInfo(userInfo) {
    LoggingModule.info("[BaseInfoModule]: setUserInfo");
    this.userInfo = userInfo;
  }
  fetchUserInfo() {
    LoggingModule.info("[BaseInfoModule]: fetchUserInfo");
    return Promise.resolve({});
  }
}
var BaseInfoModule_default = BaseInfoModule;
export {
  BaseInfoModule_default as default
};
